// extracted by mini-css-extract-plugin
export default {"helperText":"SelectAutocompleteInputField_helperText__KecUG","selectField":"SelectAutocompleteInputField_selectField__XAUA6"};